module.exports = __webpack_public_path__ + "img/album05_18.9c90e1a3.jpg";